define('extensions/knockout/functions/trim', ['knockout'], function (ko) {
    ko.subscribable.fn.trim = function () {
        return this.mapNotNull($.trim);
    };
});